import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ux/button';
import  IconCart from '@ux/icon/cart';
import  IconX from '@ux/icon/x';
import CartContent from './CartContent';
import { FormattedMessage } from 'react-intl';
import { IconRTL } from '@px/react-utils';


class Cart extends React.Component {

  constructor() {
    super(...arguments);
    this.onChangeTimeout = null;
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    this.props.onChange && this.props.onChange();
    this.setState({ placeholders: 0 });
  }

  render() {
    const { onClose, onContinue, basket, sortedBasketItems, loading, currency, market, language, hasRestrictedDomains } = this.props;
    const handleChange = this.handleChange;
    const isBasketEmpty = Boolean(!(sortedBasketItems && sortedBasketItems.length)) && !hasRestrictedDomains;

    return (
      <div className='hc-cart' >
        <div className='headline-brand bg-light'>
          <span className='ms5'>
            <FormattedMessage id='basket' />
            {!isBasketEmpty && <span className='basket-count'> ({sortedBasketItems.length})</span>}
          </span>
          <Button
            data-eid='gce.header_cart.sales_header.close_x.click'
            design='tertiary'
            onClick={ onClose }
            className='pull-right'
          >
            <IconX />
          </Button>
        </div>
        <div className='hc-divider' />
        <CartContent
          key={ basket.requestKey }
          basket={ basket }
          sortedBasketItems={ sortedBasketItems }
          loading={ loading }
          onChange={ handleChange }
          currency={ currency }
          market={ market }
          language={ language }
          hasRestrictedDomains={ hasRestrictedDomains }
        />
        {!isBasketEmpty &&
          <div className='hc-cart-continue'>
            <Button
              data-eid='gce.header_cart.sales_header.continue_button.click'
              design='primary'
              onClick={ onContinue }
            >
              <IconRTL><IconCart width={ 20 } height={ 20 } fill='white' /></IconRTL>
              <span className='hc-cart-continue-text'><FormattedMessage id='continueToCart' /></span>
            </Button>
            <Button
              data-eid='gce.header_cart.sales_header.close_button.click'
              design='default'
              onClick={ onClose }
            >
              <FormattedMessage id='continueShopping' />
            </Button>
          </div>
        }
      </div>
    );
  }
}

Cart.propTypes = {
  currency: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  basket: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  requestKey: PropTypes.number,
  loading: PropTypes.bool,
  language: PropTypes.object.isRequired,
  sortedBasketItems: PropTypes.array,
  hasRestrictedDomains: PropTypes.bool
};

export default Cart;
